// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LifestyleProgramsRouteImport } from './routes/lifestyle-programs'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ForExpertsRouteImport } from './routes/for-experts'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as BookingsRouteRouteImport } from './routes/bookings/route'
import { Route as BookingRouteRouteImport } from './routes/booking/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WebinarsIndexRouteImport } from './routes/webinars/index'
import { Route as VideoConsultationsIndexRouteImport } from './routes/video-consultations/index'
import { Route as KnowledgeBaseIndexRouteImport } from './routes/knowledge-base/index'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as CheckoutIndexRouteImport } from './routes/checkout/index'
import { Route as CareExaminationsIndexRouteImport } from './routes/care-examinations/index'
import { Route as WebinarsWebinarIdRouteImport } from './routes/webinars/$webinarId'
import { Route as ResetPasswordResetTokenRouteImport } from './routes/reset-password/$resetToken'
import { Route as LoginTwoFactorRouteImport } from './routes/login_.two-factor'
import { Route as LifestyleProgramsProgramIdRouteImport } from './routes/lifestyle-programs_.$programId'
import { Route as KnowledgeBaseArticleIdRouteImport } from './routes/knowledge-base/$articleId'
import { Route as EventsEventIdRouteImport } from './routes/events/$eventId'
import { Route as ConfirmEmailCodeRouteImport } from './routes/confirm-email/$code'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as CareExaminationsServiceIdRouteImport } from './routes/care-examinations/$serviceId'
import { Route as BookingsIndexRouteImport } from './routes/bookings/index'
import { Route as BookingsAppointmentIdRouteImport } from './routes/bookings/$appointmentId'
import { Route as BookingVideoConsultationRouteImport } from './routes/booking/video-consultation'
import { Route as BookingSuccessRouteImport } from './routes/booking/success'
import { Route as BookingExaminationRouteImport } from './routes/booking/examination'
import { Route as BookingCheckoutRouteImport } from './routes/booking/checkout'
import { Route as WebinarJoinTokenRouteImport } from './routes/webinar/join.$token'
import { Route as BookingsMeetAppointmentIdRouteImport } from './routes/bookings/meet.$appointmentId'
import { Route as BookingsEventsBookingIdRouteImport } from './routes/bookings/events.$bookingId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PackagesRoute = PackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LifestyleProgramsRoute = LifestyleProgramsRouteImport.update({
            id: '/lifestyle-programs',path: '/lifestyle-programs',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ForExpertsRoute = ForExpertsRouteImport.update({
            id: '/for-experts',path: '/for-experts',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const BookingsRouteRoute = BookingsRouteRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => rootRouteImport
          })
const BookingRouteRoute = BookingRouteRouteImport.update({
            id: '/booking',path: '/booking',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WebinarsIndexRoute = WebinarsIndexRouteImport.update({
            id: '/webinars/',path: '/webinars/',getParentRoute: () => rootRouteImport
          })
const VideoConsultationsIndexRoute = VideoConsultationsIndexRouteImport.update({
            id: '/video-consultations/',path: '/video-consultations/',getParentRoute: () => rootRouteImport
          })
const KnowledgeBaseIndexRoute = KnowledgeBaseIndexRouteImport.update({
            id: '/knowledge-base/',path: '/knowledge-base/',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
            id: '/checkout/',path: '/checkout/',getParentRoute: () => rootRouteImport
          })
const CareExaminationsIndexRoute = CareExaminationsIndexRouteImport.update({
            id: '/care-examinations/',path: '/care-examinations/',getParentRoute: () => rootRouteImport
          })
const WebinarsWebinarIdRoute = WebinarsWebinarIdRouteImport.update({
            id: '/webinars/$webinarId',path: '/webinars/$webinarId',getParentRoute: () => rootRouteImport
          })
const ResetPasswordResetTokenRoute = ResetPasswordResetTokenRouteImport.update({
            id: '/reset-password/$resetToken',path: '/reset-password/$resetToken',getParentRoute: () => rootRouteImport
          })
const LoginTwoFactorRoute = LoginTwoFactorRouteImport.update({
            id: '/login_/two-factor',path: '/login/two-factor',getParentRoute: () => rootRouteImport
          })
const LifestyleProgramsProgramIdRoute = LifestyleProgramsProgramIdRouteImport.update({
            id: '/lifestyle-programs_/$programId',path: '/lifestyle-programs/$programId',getParentRoute: () => rootRouteImport
          })
const KnowledgeBaseArticleIdRoute = KnowledgeBaseArticleIdRouteImport.update({
            id: '/knowledge-base/$articleId',path: '/knowledge-base/$articleId',getParentRoute: () => rootRouteImport
          })
const EventsEventIdRoute = EventsEventIdRouteImport.update({
            id: '/events/$eventId',path: '/events/$eventId',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailCodeRoute = ConfirmEmailCodeRouteImport.update({
            id: '/confirm-email/$code',path: '/confirm-email/$code',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const CareExaminationsServiceIdRoute = CareExaminationsServiceIdRouteImport.update({
            id: '/care-examinations/$serviceId',path: '/care-examinations/$serviceId',getParentRoute: () => rootRouteImport
          })
const BookingsIndexRoute = BookingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BookingsRouteRoute
          })
const BookingsAppointmentIdRoute = BookingsAppointmentIdRouteImport.update({
            id: '/$appointmentId',path: '/$appointmentId',getParentRoute: () => BookingsRouteRoute
          })
const BookingVideoConsultationRoute = BookingVideoConsultationRouteImport.update({
            id: '/video-consultation',path: '/video-consultation',getParentRoute: () => BookingRouteRoute
          })
const BookingSuccessRoute = BookingSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => BookingRouteRoute
          })
const BookingExaminationRoute = BookingExaminationRouteImport.update({
            id: '/examination',path: '/examination',getParentRoute: () => BookingRouteRoute
          })
const BookingCheckoutRoute = BookingCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => BookingRouteRoute
          })
const WebinarJoinTokenRoute = WebinarJoinTokenRouteImport.update({
            id: '/webinar/join/$token',path: '/webinar/join/$token',getParentRoute: () => rootRouteImport
          })
const BookingsMeetAppointmentIdRoute = BookingsMeetAppointmentIdRouteImport.update({
            id: '/meet/$appointmentId',path: '/meet/$appointmentId',getParentRoute: () => BookingsRouteRoute
          })
const BookingsEventsBookingIdRoute = BookingsEventsBookingIdRouteImport.update({
            id: '/events/$bookingId',path: '/events/$bookingId',getParentRoute: () => BookingsRouteRoute
          })





const BookingRouteRouteChildren = {
  BookingCheckoutRoute: BookingCheckoutRoute,BookingExaminationRoute: BookingExaminationRoute,BookingSuccessRoute: BookingSuccessRoute,BookingVideoConsultationRoute: BookingVideoConsultationRoute
}

const BookingRouteRouteWithChildren = BookingRouteRoute._addFileChildren(BookingRouteRouteChildren)




const BookingsRouteRouteChildren = {
  BookingsAppointmentIdRoute: BookingsAppointmentIdRoute,BookingsIndexRoute: BookingsIndexRoute,BookingsEventsBookingIdRoute: BookingsEventsBookingIdRoute,BookingsMeetAppointmentIdRoute: BookingsMeetAppointmentIdRoute
}

const BookingsRouteRouteWithChildren = BookingsRouteRoute._addFileChildren(BookingsRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BookingRouteRoute: BookingRouteRouteWithChildren,BookingsRouteRoute: BookingsRouteRouteWithChildren,SplatRoute: SplatRoute,AboutRoute: AboutRoute,ApplyRoute: ApplyRoute,ContactRoute: ContactRoute,ForExpertsRoute: ForExpertsRoute,ForgotPasswordRoute: ForgotPasswordRoute,LifestyleProgramsRoute: LifestyleProgramsRoute,LoginRoute: LoginRoute,PackagesRoute: PackagesRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RegisterRoute: RegisterRoute,TermsRoute: TermsRoute,CareExaminationsServiceIdRoute: CareExaminationsServiceIdRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,ConfirmEmailCodeRoute: ConfirmEmailCodeRoute,EventsEventIdRoute: EventsEventIdRoute,KnowledgeBaseArticleIdRoute: KnowledgeBaseArticleIdRoute,LifestyleProgramsProgramIdRoute: LifestyleProgramsProgramIdRoute,LoginTwoFactorRoute: LoginTwoFactorRoute,ResetPasswordResetTokenRoute: ResetPasswordResetTokenRoute,WebinarsWebinarIdRoute: WebinarsWebinarIdRoute,CareExaminationsIndexRoute: CareExaminationsIndexRoute,CheckoutIndexRoute: CheckoutIndexRoute,EventsIndexRoute: EventsIndexRoute,KnowledgeBaseIndexRoute: KnowledgeBaseIndexRoute,VideoConsultationsIndexRoute: VideoConsultationsIndexRoute,WebinarsIndexRoute: WebinarsIndexRoute,WebinarJoinTokenRoute: WebinarJoinTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)